<template>
	<el-drawer title="修改洗美卡" :visible.sync="visible" @close='close' size="1000px" :close-on-press-escape="false" :wrapperClosable="false"
		id="comDrawer" :modal-append-to-body="false">
		<div class="drawerView">
			<div class="drawerViewT">
				<div class="drawerCom">
					<div class="drawerComL">卡号</div>
					<div class="drawerComR">
						<el-input v-model="curCard.card_number" disabled placeholder="请输入" style="width:250px;"></el-input>
					</div>
				</div>
				<div class="drawerCom">
					<div class="drawerComL">类型</div>
					<div class="drawerComR">
						<el-radio-group v-model="type" style="width:350px;">
							<el-radio :label="0" border>还原</el-radio>
							<el-radio :label="1" border>消费</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="drawerCom">
					<div class="drawerComL">消费时间</div>
					<div class="drawerComR">
						<el-date-picker  v-model="time" type="datetime" placeholder="选择日期时间" style="width:250px;">
						</el-date-picker>
					</div>
				</div>
				<div class="drawerCom">
					<div class="drawerComL">门店</div>
					<div class="drawerComR">
						<el-select v-model="shopId" class="titleSelect">
							<el-option v-for="item in shopList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id" >
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="drawerCom">
					<div class="drawerComL">操作人</div>
					<div class="drawerComR">
						<el-select v-model="staffId" filterable placeholder="请选择" style="width:400px;">
							<el-option v-for="item in staffList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="drawerCom">
					<div class="drawerComL">订单号</div>
					<div class="drawerComR">
						<el-input  v-model="orderNo" placeholder="请输入" style="width: 600px;" resize="none"></el-input>
					</div>
				</div>
			</div>
			<div class="drawerViewB">
				<div class="btn2" @click="close">取消</div>
				<div class="btn" @click="submit">确定</div>
			</div>
		</div>

	</el-drawer>
</template>

<script>
	export default {
		data() {
			return {
				visible: true,
				
				staffList:[],
				shopList:this.$store.state.allShopList,
				
				type:0,
				time:'',
				shopId:'',
				staffId:'',
				orderNo:'',
			}
		},
		props:{
			memberId:{
				default:''
			},
			curCard:{
				default:()=>{
					return {}
				},
			},
			curRecordIndex:{
				default:-1
			},
			
		},
		mounted(){
			if(this.curRecordIndex>-1){
				let item = this.curCard.consume_record[this.curRecordIndex]
				this.type = item.consume_type
				this.time = item.consume_time?new Date(item.consume_time*1000):''
				this.shopId = item.shop_id
				this.staffId = item.user_id
				this.orderNo = item.order_num
			}
			this.getStaffList()
		},
		methods: {
			close() {
				this.$emit("submit", {type:'close'});
			},
			//提交
			submit(){
				let item = {
					"consume_time": this.$public.FTimeStr10(this.time),
					"consume_type": this.type,
					"shop_id": this.shopId,
					"shop_name": this.$public.getArrItemByKey(this.shopList,'shop_id',this.shopId).shop_name,
					"user_id": this.staffId,
					"user_name": this.$public.getArrItemByKey(this.staffList,'value',this.staffId).label,
					"order_num": this.orderNo,
				}
				let record = this.curCard.consume_record;
				if(this.curRecordIndex>-1){
					record[this.curRecordIndex] = item
				}else{
					record.push(item)
				}
				record.sort(function(a, b){return Number(a.consume_time) - Number(b.consume_time)})
				let params = {
					"member_id": this.memberId,
					"card_number": this.curCard.card_number,
					"record": record,
				}
				console.log(params)
				this.$http.post(process.env.VUE_APP_member + '/api/MemberBindCard/UpdateCardConsumeRecord', params).then((res) => {
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: '操作成功'
						});
						this.$emit("submit", {type:'success'});
					}
				})
			},
			getStaffList(){
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_baseData+'/api/StaffInfo/simple/list', {}).then(res => {
					loading.close()
					if (res.code == 0) {
						this.staffList = res.data
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	#comDrawer {
		::v-deep .el-drawer__header {
			padding: 20px;
			margin-bottom: 0;
		}

		::v-deep .el-drawer__body {
			height: calc(100% - 65px);
			overflow-y: auto;
		}
	}

	.drawerView {
		height: 100%;
		display: flex;
		flex-direction: column;
		.drawerViewT {
			flex: 1;
			box-sizing: border-box;
			border-top: solid 1px #F2F2F2;
			overflow-y: scroll;
			.drawerCom{
				display: flex;
				margin-top: 32px;
				.drawerComL{
					width: 132px;
					margin-right: 22px;
					font-size: 14px;
					color: #343440;
					text-align: right;
					line-height: 20px;
					margin-top: 12px;
				}
				.drawerComR{
					flex: 1;
					.drawerSelect{
						display: flex;
						.drawerSelectItem{
							width: 128px;
							height: 44px;
							box-sizing: border-box;
							font-size: 14px;
							color: #69697B;
							text-align: center;
							line-height: 44px;
							position: relative;
							background: #FAFAFD;
							border-radius: 8px;
							margin-right: 16px;
							div:nth-of-type(1){
								position: absolute;
								left: 16px;
								top: 0;
								bottom: 0;
								margin: auto 0;
								width: 16px;
								height: 16px;
								border-radius: 100%;
								border: solid 1px #B0B0BF;
							}
						}
						.drawerSelectActiveItem{
							width: 128px;
							height: 44px;
							box-sizing: border-box;
							font-size: 14px;
							color: #577BFF;
							text-align: center;
							line-height: 44px;
							position: relative;
							background: #FAFAFD;
							border-radius: 8px;
							margin-right: 16px;
							border: 1px solid #577BFF;
							div:nth-of-type(1){
								position: absolute;
								left: 16px;
								top: 0;
								bottom: 0;
								margin: auto 0;
								width: 4px;
								height: 4px;
								border-radius: 100%;
								border: solid 6px #577BFF;
							}
						}
					}
				}
			}
		}

		.drawerViewT::-webkit-scrollbar {
			display: none;
		}

		.drawerViewB {
			height: 60px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;
			border-top: solid 1px #F2F2F2;
			box-sizing: border-box;

			.btn {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				cursor: pointer;
				margin-left: 20px;
			}

			.btn2 {
				width: 98px;
				line-height: 40px;
				text-align: center;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				cursor: pointer;
				box-sizing: border-box;
				border: solid 1px #577BFF;
				color: #577BFF;
			}
		}
	}
</style>
